export default __webpack_public_path__ + "static/media/GHSI Notice ASM 22 March 2022.5db04bd7.pdf";